import React from 'react'
import scrollIntoView from 'smooth-scroll-into-view-if-needed'

class ScrollWebinarToView extends React.Component {
  componentDidMount() {
    this.slideToWebinar()
  }

  getParameterByName(name, url = window.location.href) {
    const newName = name.replace(/[\[\]]/g, '\\$&')
    const regex = new RegExp(`[?&]${newName}(=([^&#]*)|&|#|$)`)
    const results = regex.exec(url)

    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }

  slideToWebinar() {
    const num = this.getParameterByName('webinar')
    if (num) {
      setTimeout(() => {
        const scrollToEl = document.querySelector(`div[data-scrollto="${num}"]`)
        if (scrollToEl) {
          let blockPosition = 'start'
          if (window.innerWidth > 768) {
            blockPosition = 'center'
          }
          scrollIntoView(scrollToEl, {
            block: blockPosition,
            behavior: 'smooth',
            scrollMode: 'if-needed',
            duration: 1500
          })
        }
      }, 500)
    }
  }

  render() {
    return null
  }
}

export default ScrollWebinarToView
